import { invoiceStatuses } from './statuses';

export const invoiceStatusKeys = {
    [invoiceStatuses.FAILED]: 'invoices.paymentStatuses.failed',
    [invoiceStatuses.TO_BE_CHARGED]: 'invoices.paymentStatuses.toBeCharged',
    [invoiceStatuses.PAID]: 'invoices.paymentStatuses.paid',
    [invoiceStatuses.UNPAID]: 'invoices.paymentStatuses.unpaid',
};

export default invoiceStatusKeys;
